import { OrganisationDto } from "./organisation.dto";

export const DEFAULT_ORGA: OrganisationDto = {
  code: "ORGA",
  name: "ORGA_DEFAULT",
  logo: "",
};

export class UserModel {
  constructor(
    public userName: string,
    public firstName: string,
    public lastName: string,
    public organizations: OrganisationDto[]
  ) {}

  get fullName(): string {
    return this.firstName + " " + this.lastName;
  }

  get organizationList(): OrganisationDto[] {
    return this.organizations.sort((organizationA, organizationB) => {
      const nameA = organizationA.name.toUpperCase();
      const nameB = organizationB.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  get orga(): OrganisationDto {
    return this.organizationList.find((o) => o.code === "ABYLAMOBILE") ?? this.organizationList?.[0] ?? DEFAULT_ORGA;
  }
}
